import { Injectable } from '@angular/core'
import { AuthHttpHeaderService } from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class MbAuthHttpHeaderService extends AuthHttpHeaderService {

  protected isOccUrl (url: string) {
    return url.includes(this.occEndpoints.getBaseUrl()) && !url.includes('basesites')
  }
}
